import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=d1a48da0&"
import script from "./Trade.vue?vue&type=script&lang=js&"
export * from "./Trade.vue?vue&type=script&lang=js&"
import style0 from "./Trade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports